import { ChangeEventHandler, forwardRef, Ref } from 'react';
import { cn } from '../../utils';

type TextareaProps = {
    name: string;
    helpText?: string;
    value?: string;
    disabled?: boolean;
    onChange?: ChangeEventHandler<HTMLTextAreaElement>;
    placeholder?: string;
    className?: string;
    error?: string;
    required?: boolean;
};

export default forwardRef(function Textarea(
    {
        name,
        value,
        disabled = false,
        onChange,
        placeholder,
        helpText,
        error,
        className,
        ...rest
    }: TextareaProps,
    ref: Ref<HTMLTextAreaElement>,
) {
    return (
        <div className="alli-relative alli-mt-2">
            <textarea
                data-testid={`Textarea-${name}`}
                ref={ref}
                name={name}
                id={name}
                className={cn(
                    'alli-block alli-w-full alli-rounded-md alli-border-0 alli-py-2 alli-text-blue-gray-700 alli-ring-1 alli-ring-inset alli-ring-gray-400 focus:alli-ring-1 focus:alli-ring-inset sm:alli-text-sm sm:alli-leading-6',
                    {
                        'alli-text-blue-gray-700 alli-ring-red-400 placeholder:alli-text-gray-700 focus:alli-ring-red-400':
                            error,
                        'alli-cursor-not-allowed alli-border-gray-400 alli-bg-gray-300 alli-text-gray-600':
                            disabled,
                        'alli-shadow-sm': !disabled && !error,
                        'alli-shadow-sm focus:alli-shadow-[0_0_4px_rgba(12,105,234,0.30)]':
                            !error,
                    },
                    className,
                )}
                disabled={disabled}
                defaultValue={value}
                onChange={onChange}
                placeholder={placeholder}
                {...rest}
            />
            {helpText && !error && (
                <p className="mt-1 alli-py-2 alli-text-sm alli-text-gray-700">
                    {helpText}
                </p>
            )}
            {error && (
                <p className="mt-1 alli-py-2 alli-text-sm alli-text-red-400">
                    {error}
                </p>
            )}
        </div>
    );
});
